import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PromptDialogOnSide } from 'common/components/PromptDialogOnSide/PromptDialogOnSide';
import { styles } from 'common/components/PromptDialogOnSide/PromptDialogOnSide.styles';
import { FormInput } from 'common/form/components/FormInput';
import { fieldIsRequiredValidator } from 'common/form/validators';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { CashFlowAdjustmentType } from '../AddCashFlowAdjustmentDialog/AddCashFlowAdjustmentDialog';

interface FormValues {
  text?: string | null;
}

export interface EditCashFlowAdjustmentTextDialogProps extends DialogComponentProps<string | undefined | null> {
  type: CashFlowAdjustmentType;
  text?: string | null;
}

export const EditCashFlowAdjustmentTextDialog: React.FC<EditCashFlowAdjustmentTextDialogProps> = ({
  isOpen,
  onReject,
  onResolve,
  text,
  type,
}) => {
  const { t } = useTranslation();

  const schema: yup.SchemaOf<FormValues> = yup.object({
    text: fieldIsRequiredValidator(),
  });

  const formMethods = useForm<FormValues>({
    defaultValues: {
      text,
    } as FormValues,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  const handleSubmit = formMethods.handleSubmit(async (data) => {
    onResolve(data.text);
  });

  return (
    <PromptDialogOnSide
      onClose={() => onReject()}
      open={isOpen}
      title={
        type == CashFlowAdjustmentType.Income
          ? t('fintelligenceReport.editCashFlowAdjustmentTextDialog.income.title')
          : t('fintelligenceReport.editCashFlowAdjustmentTextDialog.expense.title')
      }
    >
      <FormProvider {...formMethods}>
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Box>
            <FormInput autoComplete="text" autoFocus fullWidth name="text" type="text" />
          </Box>

          <Stack mt={3} spacing={1}>
            <Button color="primary" sx={styles.button} type="submit">
              <Typography color="white" variant="bodyL">
                {t('fintelligenceReport.editCashFlowAdjustmentTextDialog.save')}
              </Typography>
            </Button>
            <Button color="tertiaryButton" onClick={() => onReject()} sx={styles.button}>
              <Typography color="blue.dark" variant="bodyL">
                {t('common:cancel')}
              </Typography>
            </Button>
          </Stack>
        </Box>
      </FormProvider>
    </PromptDialogOnSide>
  );
};
